import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const AddPathologyIcon = (props) => {
  const { getAlterColor } = useContext(themeContext);
 
  const getIconColor = () => {
    if (props.isChildStudyActive) return getAlterColor("#FFF","#212121"); 
    if (props.active) return "#0085FF"; 
    return (!props.open)?getAlterColor("white","black"):"white"; 
  };
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="28"
    //   height="28"
    //   viewBox="0 0 28 28"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M0.666748 13.9993C0.666748 6.63935 6.64008 0.666016 14.0001 0.666016C21.3601 0.666016 27.3334 6.63935 27.3334 13.9993C27.3334 21.3594 21.3601 27.3327 14.0001 27.3327C6.64008 27.3327 0.666748 21.3594 0.666748 13.9993ZM15.3334 15.3327H20.6667V12.666H15.3334V7.33268H12.6667V12.666H7.33341V15.3327H12.6667V20.666H15.3334V15.3327Z"
    //     fill={props.active?"#0085FF":"#DADADA"}
    //     fillOpacity={props.active?"":"0.54"}
    //   />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 13H17V11H13V7H11V11H7V13H11V17H13V13Z"
        //fill={!props.open && themeName === "light" && !props.active ? "#212121" : props.active?"#0085FF": "#DADADA"}
        fill={getIconColor()}
        fillOpacity={props.active?"":"0.54"}
      />
      {/* <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 13H17V11H13V7H11V11H7V13H11V17H13V13Z"
        fill={!props.open && themeName === "light" && !props.active ? "#212121" : props.active?"#0085FF": "#DADADA"}
        fillOpacity={props.active?"":"0.54"}
      /> */}
    </svg>
  );
};

export default AddPathologyIcon;
